import SearchTerm2 from "./searchTerm2.container";

export default SearchTerm2;
